import COLOR from '@Src/commons/Colors';
import { Collapse } from 'antd';
import styled from 'styled-components';

export const StyledOnboardingContainer = styled.div`
  // padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  min-height: calc(100% - 166px);
  max-height: calc(100% - 48px);
  overflow-y: auto;

  // padding-right: 10px; // to avoid scrollbar override

  .ant-form {
    gap: 16px;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }
`;

export const StyledCollapse = styled(Collapse)`
  background: ${COLOR.GRAY_2};
  border-radius: 8px !important;
  border: 0 !important;
  .ant-collapse-item {
    border-bottom: 0 !important;
    .ant-collapse-header {
      padding: 12px 8px !important;
      .ant-collapse-expand-icon {
        color: ${COLOR.GRAY_9};
        width: 16px;
        height: 16px;
      }
      .ant-collapse-header-text {
        color: ${COLOR.GRAY_8};
        text-transform: uppercase;
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
      }
    }

    .ant-collapse-content {
      border-top: 0;

      &-box {
        padding: 16px 24px !important;
        background: ${COLOR.GRAY_1};
        border: 1px solid ${COLOR.GRAY_2};
        border-radius: 0px 0px 8px 8px;

        display: flex;
        flex-direction: column;
        gap: 16px;
      }
    }
  }
`;
